// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"uF-z","smallCardRow":"vF-z","largeCardRow":"wF-z","productSearchRow":"xF-z","curatedRow":"yF-z"};